import { Modal, Row, Col, Tooltip, Button } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useEffect, useState } from "react";
import PriceEditTable from "./PriceEditTable";
export default props => {
  const {visible,close,dataSource,batchUpdatePrice=()=>{}} = props
  const [newTable,setNewTable] = useState([])
  const [newDataSource, setDataSource] = useState(dataSource)
  useEffect(()=>{
    setDataSource(dataSource)
  },[dataSource])
  const updatePrice = (data) => {
    let list = dataSource.map(item=>{
      if(item.skuForStoreId == data.skuForStoreId) item.currentPrice = data.currentPrice
      return item
    })
    if(!list.find(item=>item.skuForStoreId == data.skuForStoreId)) list.push(data)
    setNewTable(list)
  }
  const deleteTableItem = (skuForStoreId) => {
    setDataSource(newDataSource.filter(item=>item.skuForStoreId!=skuForStoreId))
    setNewTable(newTable.filter(item=>item.skuForStoreId!=skuForStoreId))
  }
  const columns = [
    { title: '序号', dataIndex: '', key: 'index', render: (text,record,index)=> index+1 },
    { title: '商品信息', dataIndex: 'goodsName', key: 'goodsName', render: (text,record)=> (
      <span style={{fontSize: '12px'}}>
        <Row>
          <Col style={{color: '#3e9eff'}}>{record.goodsName}</Col>
        </Row>
        <Row>
          <Col>商品编码：{record.goodsCode}</Col>
        </Row>
        <Row>
          <Col>商品条码：{record.barCode}</Col>
        </Row>
      </span>
    )},
    { title: '商品类别', dataIndex: 'categoryName', key: 'categoryName' },
    { title: '规格', dataIndex: 'spec', key: 'spec' },
    { title: '单位', dataIndex: 'unit', key: 'unit' },
    { title: ()=>{
        return (<Tooltip title="移动平均价">成本价 <ExclamationCircleFilled /></Tooltip>)
      }, dataIndex: 'moveAveragePrice', key: 'moveAveragePrice', render: (text, record) =>text?<span>{text}</span>:<span>-</span>
    },
    { title: '零售指导价', dataIndex: 'guidePrice', key: 'guidePrice', render: (text, record) =>text?<span>{text}</span>:<span>-</span>  },
    { title: '当前销售价', dataIndex: 'currentPrice', key: 'currentPrice', editable: true },
    {
      title: ()=>{
        return (<Tooltip title="毛利率=（当前销售价-成本价）/当前销售价*100%">毛利率% <ExclamationCircleFilled /></Tooltip>)
      },
      dataIndex: 'profitView',
      key: 'profitView',
      render: (text, record) => (record.moveAveragePrice && record.currentPrice)? ((((record.currentPrice-record.moveAveragePrice)/record.currentPrice)*100).toFixed(2) + '%') : <span>-</span>
    },
    {
      title: '操作',
      dataIndex: '',
      key: 'x',
      render: (text,record,index) => (
        <Button type="link" onClick={()=>deleteTableItem(record.skuForStoreId)}>删除</Button>
      ),
    },
  ];
  return (
    <Modal
      visible={visible}
      width="60%"
      title="批量设置销售价"
      onCancel={close}
      onOk={()=>batchUpdatePrice(newTable)}
      cancelText="取消"
      okText="提交审核"
    >
      <PriceEditTable
        tableData={newDataSource}
        pagination={false}
        tableColumns={columns}
        updatePrice={updatePrice}
      />
    </Modal>
  );
}
